export default function StatistiqueSection() {
  return (
    <section className="bg-white py-24 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Badge de statistique */}
        <div className="inline-flex items-center gap-4 bg-[#3D2817] text-white px-8 py-4 rounded-full mb-8">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-star-fill text-[#E8956F] text-2xl"></i>
          </div>
          <div>
            <div className="text-4xl font-bold">1 femme sur 10</div>
            <div className="text-sm text-white/80">est touchée par l'endométriose</div>
          </div>
        </div>

        {/* Texte explicatif */}
        <div className="max-w-4xl">
          <p className="text-lg md:text-xl text-[#3A3A3A] leading-relaxed mb-6" style={{ fontFamily: 'Playfair Display, serif', lineHeight: '1.8' }}>
            Dans un monde équestre composé majoritairement de femmes, des milliers de cavalières voient leur pratique, leur performance et leur relation avec leur cheval impactées par la douleur.
          </p>
          <p className="text-lg md:text-xl text-[#3A3A3A] leading-relaxed" style={{ fontFamily: 'Playfair Display, serif', lineHeight: '1.8' }}>
            L'endométriose est une maladie chronique reconnue qui touche environ 10 % des femmes. Elle se caractérise par la présence de tissu semblable à l'endomètre en dehors de l'utérus, provoquant des douleurs parfois intenses et invalidantes, souvent aggravées par l'effort, le stress, la fatigue ou le froid.
          </p>
        </div>
      </div>
    </section>
  );
}
